<template>
  <a-modal
    :title="$t('title.receiptDetailEdit')"
    :centered="true"
    :visible="visible"
    width="70%"
    :destroyOnClose="destroyOnClose"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-descriptions :column="3" bordered style="margin-bottom: -15px">
        <a-descriptions-item :label="$t('business.label.receiptOrderNo')">
          <span>{{data.order.no}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.supplier')" :span="2">
          <span>{{data.supplier.name}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.itemNo')">
          <span>{{data.item.no}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.itemName')">
          <span>{{data.item.name}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.storer')">
          <span>{{data.storer.name}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.specification')">
          <span>{{data.pack.specification}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.factor')">
          <span>{{data.pack.factor}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.uom')">
          <span>{{data.pack.uom}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.lot')">
          <span>{{data.lot.no}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.productionDate')">
          <span>{{data.lot.productionDate}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.validUntil')">
          <span>{{data.lot.validUntil}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.storageRoom')">
          <a-input v-model="data.storageRoom.name" readOnly style="width: 100%" @dblclick="onStorageRoomFetching" @pressEnter="onStorageRoomFetching"/>
          <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChanged"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.containerNo')">
          <a-input v-model="data.container.no" readOnly style="width: 100%" @dblclick="onContainerFetching" @pressEnter="onContainerFetching"/>
          <container-modal ref="containerModal" @change="onContainerChanged"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.invoiceQuantity')">
          <a-input-number v-model="data.detail.invoiceQuantity" :min="1" style="width: 100%"/>
        </a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-modal>
</template>
<script>
import api from '@/api'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { post } from '@/api/Api'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Container } from '@/api/dto/common/Container'
import { Lot } from '@/api/dto/common/Lot'
import { Batch } from '@/api/dto/common/Batch'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'
import { Storer } from '@/api/dto/common/Storer'
import { Customer } from '@/api/dto/common/Customer'
import { ReceivingFactoryView } from '@/api/dto/view/ReceivingFactoryView'
import { ReceiptDetail, ReceiptOrder } from '@/api/dto/order/ReceiptOrder'

export default {
  name: 'ModifyModal',
  components: { ContainerModal, StorageRoomModal },
  data() {
    return {
      visible: false,
      loading: false,
      destroyOnClose: true,
      data: new ReceivingFactoryView()
    }
  },
  methods: {
    open(data) {
      this.data.order = new ReceiptOrder(data.order)
      this.data.detail = new ReceiptDetail(data.detail)
      this.data.storer = new Storer(data.storer)
      this.data.supplier = new Customer(data.supplier)
      this.data.item = new Item(data.item)
      this.data.pack = new Pack(data.pack)
      this.data.lot = new Lot(data.lot)
      this.data.batch = new Batch(data.batch)
      this.data.storageRoom = new StorageRoom(data.storageRoom)
      this.data.container = new Container(data.container)
      this.visible = true
    },
    onStorageRoomFetching() {
      this.$refs.storageRoomModal.open()
    },
    onContainerFetching() {
      this.$refs.containerModal.open({ available: true, physical: true, 'storageRoom.id': this.data.storageRoom.id })
    },
    onStorageRoomChanged(data) {
      this.data.storageRoom = new StorageRoom(data[0])
    },
    onContainerChanged(data) {
      this.data.container = new Container(data[0])
    },
    handleOk() {
      this.loading = true
      const args = {
        id: this.data.detail.id,
        lot: this.data.lot.skipNulls(),
        batch: this.data.batch.skipNulls(),
        storageRoom: this.data.storageRoom.skipNulls(),
        container: this.data.container.skipNulls(),
        invoiceQuantity: this.data.detail.invoiceQuantity
      }
      post(api.receivingReceiverModify, { type: 'normalInboundReceiver' }, args).then(res => {
        if (res.success) {
          this.$message.success('修改成功')
          this.$emit('success')
          this.handleCancel()
        }
      }).finally(() => this.loading = false)
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>